export enum Links {
  HOME = '/',
  TALK = '/talk-to-experts',
  REQUEST = '/request-a-demo',
  SIGN = '/sign-in',
  TEMPLATES = '/templates',
  BLOG = '/blog',
  INVESTORS = '/investors',
  PRODUCTS = '/products',
  PRICING = '/pricing',
  CONCIERGE = '/concierge-services',
}

export enum ProductLinks {
  TEMPLATES = '/templates/about',
  VISUAL = '/visual-app-builder',
  BROWSER = '/in-browser-apps-preview',
  CONTINUOUS = '/continuous-integration',
  BACKEND = '/backend-as-a-service',
  APP_LANDING = '/app-landing-page',
  STORE = '/store-manager',
  SCREENSHOTS = '/screenshots-generator',
  TERMS = '/terms-and-policies-generator',
  AI = '/ai',
}

export enum ScrollLinks {
  WHAT_IS_CODEPLATFORM = 'what-is-codeplatform',
  WHY_CODEPLATFROM = 'why-codeplatform',
  HOW_CODEPLATFORM_WORKS = 'how-codeplatform-works',
  WHO_IS_CODEPLATFORM_FOR = 'who-is codeplatform-for',
}

export enum LocalKeys {
  PRICING_PLAN = 'pricingPlan',
  APP_PERIOD = 'appPeriod',
  TEAM_PERIOD = 'teamPeriod',
}
